import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar
} from '@mui/material';
import { 
  SummarizeOutlined,
  Logout,
  ShoppingCart,
  Restaurant,
  Storefront,
  Factory,
  LocalShipping,
  PictureAsPdf,
  CalendarMonth
} from '@mui/icons-material';
import { supabase } from '../configs/supabase';
import { routingPath } from '../utils/path';

const drawerWidth = 210;

export default function Sidebar() {
  const navigate = useNavigate();
  
  // ログアウト処理
  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      navigate(routingPath.login);
    } catch (error) {
      console.error("ログアウト失敗:", error);
    }
  };

  return(
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth, 
            boxSizing: 'border-box',
            backgroundColor: '#2a2a2e',
            color: '#fff',
            boxShadow: '2px 0 4px -2px rgba(0,0,0,0.2)',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            <ListItemButton onClick={() => navigate(routingPath.admin.orderList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <ShoppingCart />
              </ListItemIcon>
              <ListItemText>
                受注一覧
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.orderCsv)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <SummarizeOutlined />
              </ListItemIcon>
              <ListItemText>
                受注CSV管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.productList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <Restaurant />
              </ListItemIcon>
              <ListItemText>
                商品管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.customerList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <Storefront />
              </ListItemIcon>
              <ListItemText>
                顧客管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.customerProductList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <Factory />
              </ListItemIcon>
              <ListItemText>
                顧客商品管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.customerShipList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <LocalShipping />
              </ListItemIcon>
              <ListItemText>
                顧客配送先管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.deliveryList)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <PictureAsPdf />
              </ListItemIcon>
              <ListItemText>
                納品管理
              </ListItemText>
            </ListItemButton>

            <ListItemButton onClick={() => navigate(routingPath.admin.calendarSetting)}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <CalendarMonth />
              </ListItemIcon>
              <ListItemText>
                カレンダー設定
              </ListItemText>
            </ListItemButton>

            <Divider />

            <ListItemButton onClick={handleLogout}>
              <ListItemIcon sx={{ color: '#fff' }}>
                <Logout />
              </ListItemIcon>
              <ListItemText>
                ログアウト
              </ListItemText>
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
  );
};
